import * as React from 'react';
import { SVGProps } from 'react';

const IconYoutubeSizeS = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M13.753 5.315a1.503 1.503 0 0 0-1.058-1.058C11.756 4 8 4 8 4s-3.756 0-4.695.247c-.504.138-.92.554-1.058 1.068C2 6.254 2 8.2 2 8.2s0 1.957.247 2.886c.139.514.544.92 1.058 1.058.949.257 4.695.257 4.695.257s3.756 0 4.695-.247c.514-.139.92-.544 1.058-1.058C14 10.158 14 8.211 14 8.211s.01-1.957-.247-2.896ZM6.804 10V6.402l3.123 1.799L6.804 10Z" />
  </svg>
);
export default IconYoutubeSizeS;
